import { Accordion } from "@mantine/core";
import clsx from "clsx";
import { SelectedAccountType } from "../types";
import { accountTypePreviewMeta } from "./accountTypePreviewData";
import AccountTypePreviewItem from "./AccountTypePreviewItem";
import classes from "./FeatureResourcePreviewAccordion.module.css";

export default function FeatureResourcePreviewAccordion({
  selectedAccountType,
  isMobile,
}: {
  selectedAccountType: SelectedAccountType;
  isMobile?: boolean;
}) {
  const { resources, features } = accountTypePreviewMeta;

  const activeResourceCount = resources
    .map((i) => i.activeFor.includes(selectedAccountType))
    .filter(Boolean).length;
  const activeFeatureCount = features
    .map((i) => i.activeFor.includes(selectedAccountType))
    .filter(Boolean).length;

  return (
    <Accordion
      defaultValue={isMobile ? null : "resources"}
      className={clsx(
        classes.accordionRoot,
        isMobile && classes.accordionRootMobileOnly
      )}
      classNames={{
        item: classes.accordionItem,
        control: classes.accordionControl,
        label: classes.accordionLabel,
        panel: classes.accordionPanel,
        chevron: classes.accordionChevron,
      }}
    >
      <Accordion.Item value="features">
        <Accordion.Control>
          {`${activeFeatureCount}/${features.length} Included Features`}
        </Accordion.Control>
        <Accordion.Panel>
          <div className={classes.items}>
            {features.map((item) => (
              <AccountTypePreviewItem
                key={item.title}
                item={item}
                active={item.activeFor.includes(selectedAccountType)}
              />
            ))}
          </div>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item value="resources">
        <Accordion.Control>
          {`${activeResourceCount}/${resources.length} Included Resources`}
        </Accordion.Control>
        <Accordion.Panel>
          <div className={classes.items}>
            {resources.map((item) => (
              <AccountTypePreviewItem
                key={item.title}
                item={item}
                active={item.activeFor.includes(selectedAccountType)}
              />
            ))}
          </div>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
